export default [{
    header: 'Página Web',
    icon: 'GlobeIcon',
    children: [{
            title: 'Contactos',
            route: 'messages',
            icon: 'MailIcon'
        },
        {
            title: 'Suscriptores',
            route: 'subscribers',
            icon: 'BellIcon'
        },
        {
            title: 'Blogs',
            route: 'blogs',
            icon: 'LayoutIcon'
        }
    ]
}];
